/**
 * Get millisecond timestamp from a Firestore timestamp or fallback to 0.
 */
export const getTimestampMs = (ts) => {
  if (ts && typeof ts.toMillis === 'function') return ts.toMillis();
  return 0;
};

/**
 * Sort an array of documents by a timestamp field (newest first).
 * @param {Array} items - Array of Firestore documents
 * @param {string} field - Timestamp field name (default: 'createdAt')
 * @returns {Array} Sorted array (mutates in place)
 */
export const sortByTimestamp = (items, field = 'createdAt') => {
  return items.sort((a, b) => getTimestampMs(b[field]) - getTimestampMs(a[field]));
};
